<template>
  <div>
    <v-dialog v-model="dialog.search.open" persistent max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline">Enter User's Phone Number</v-card-title>
        <v-card-text>
          <v-alert
            :value="alert.search"
            type="error"
            class="mb-3"
            transition="scale-transition"
            outline
            dismissible>
            Sorry, no investee found
          </v-alert>
          <v-text-field
            v-model="user.phone"
            v-on:keyup.enter="search"
            required
            label="Phone number"
            ref="userphone"
            prepend-icon="phone"
            prefix="+88"
            counter="11"
            clearable
            :mask="phoneMask"
            :disabled = "loading.search"
            :rules="[rules.required, rules.min]">
          </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            flat
            @click="dialog.search.open = false">
            Cancel
          </v-btn>
          <v-btn 
            :disabled="!isValidPhone()"
            color="primary"
            depressed
            @click="search"
            :loading="loading.search">
            <v-icon left>person_search</v-icon>Search
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.lightbox.open" max-width="850px">
      <v-card>
        <v-card-text>
          <v-img pa-4
            :src="dialog.lightbox.image"
            :lazy-src="imgLoading()"
          ></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.verify.open" persistent max-width="500">
      <v-card class="pa-3">
        <v-card-title class="headline">NID Verification</v-card-title>
        <v-card-text>
          <div v-if="dialog.verify.message" >
            {{dialog.verify.message}}
          </div>          
          <div v-else class="text-xs-center pa-1">
              <v-progress-circular
                :size="50"
                indeterminate
                :width="3"
                color="primary"
              ></v-progress-circular>
              <br><br>Sending request...
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn 
            v-if="dialog.verify.message"
            color="primary"
            depressed
            @click="dialog.verify.open = false"
            >Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card flat>
      <v-toolbar
        color="grey lighten-4"
        extended
        flat
      ></v-toolbar>

      <v-layout row pb-2 dark mx-4>
        <v-flex lg6 md10 offset-lg3 offset-md1>
          <v-card style="margin-top: -65px">
            <v-toolbar
              color="indigo"
              dark
              card
              indigo
              prominent>
              <v-toolbar-title class="body-3">National ID Card Verification</v-toolbar-title>

              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="retry">
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Search for an user</span>
              </v-tooltip>

            </v-toolbar>

            <v-divider></v-divider>

            <v-card-text v-if="user.id" class="py-5">
              <v-layout row dark wrap mb-4>
                <v-flex md3 xs12 offset-md1>
                  <v-img
                    :src="user.photo"
                    max-width="300"
                    class="magnify"
                    @click="imgLightbox(user.photo)"
                  >
                    <template v-slot:placeholder>
                      <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0>
                        <v-progress-circular indeterminate color="black lighten-3"></v-progress-circular>
                      </v-layout>
                    </template>
                  </v-img>
                  <!-- <img src="@/assets/profile-placeholder.png" style="max-width: 100%"> -->
                </v-flex>
                <v-flex md7 xs12>
                  <v-flex xs12 text-xs-center my-3>
                    <h2 class="display-1">{{user.name}}
                      <v-chip v-if="user.isVerified == 1" color="green" text-color="white">
                        <v-avatar>
                          <v-icon>check_circle</v-icon>
                        </v-avatar>
                        Verified
                      </v-chip>
                      <v-chip v-else-if="user.isVerified == 2" color="red" text-color="white">
                        <v-avatar>
                          <v-icon>cancel</v-icon>
                        </v-avatar>
                        Rejected
                      </v-chip>
                      <v-chip v-else color="gray" text-color="white">
                        Not Verified
                      </v-chip>
                    </h2>
                  </v-flex>
                  
                  <!-- <v-divider ml-4></v-divider> -->
                  <v-layout
                    tag="v-card-text"
                    wrap
                  >
                    <v-flex tag="strong" xs3 text-xs-right mr-3 mb-2>NID:</v-flex>
                    <v-flex  xs8>{{ user.nid.id ? user.nid.id : 'N/A'}}</v-flex>
                    <v-flex tag="strong" xs3 text-xs-right mr-3 mb-2>DOB:</v-flex>
                    <v-flex  xs8>{{ user.dob ? user.dob : 'N/A' }}</v-flex>
                    <v-flex tag="strong" xs3 text-xs-right mr-3 mb-2>Gender:</v-flex>
                    <v-flex  xs8>{{ user.gender }}</v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
              <v-layout my-3>
                <v-spacer></v-spacer>
                <v-btn 
                  depressed 
                  large
                  color="primary" 
                  @click="verify()">
                  Verify
                </v-btn>
                <v-spacer></v-spacer>
              </v-layout>
              <v-divider mx-4></v-divider>
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <template v-slot:header>
                    <h3>NID Card - User Uploads</h3>
                  </template>
                  <v-card>
                    <v-layout ma-4 text-xs-center>
                      <v-flex md6 xs12>
                        <h3 class="mb-3">NID Front Page</h3>
                        <v-img
                          :src="user.nid.front"
                          class="ma-2 magnify"
                          @click="imgLightbox(user.nid.front)"
                        >
                          <template v-slot:placeholder>
                            <v-layout
                              fill-height
                              align-center
                              justify-center
                              ma-0>
                              <v-progress-circular indeterminate color="black lighten-3"></v-progress-circular>
                            </v-layout>
                          </template>
                        </v-img>
                      </v-flex>
                      <v-flex md6 xs12>
                        <h3 class="mb-3">NID Back Page</h3>
                        <v-img
                          :src="user.nid.back"
                          class="ma-2 magnify"
                          @click="imgLightbox(user.nid.back)"
                        >
                          <template v-slot:placeholder>
                            <v-layout
                              fill-height
                              align-center
                              justify-center
                              ma-0>
                              <v-progress-circular indeterminate color="black lighten-3"></v-progress-circular>
                            </v-layout>
                          </template>
                        </v-img>
                      </v-flex>
                    </v-layout> 
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
            <div v-else class="text-xs-center pa-5">
              <v-progress-circular
                :size="100"
                indeterminate
                :width="5"
                color="primary"
              ></v-progress-circular>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>
<style scoped>
.magnify {
  cursor: zoom-in;
}
</style>
<script>
import {mapGetters} from 'vuex'

 export default {
    data: () => ({
      dialog: {
        search: {
          open: true,
          message: '',
          loading: false,
        },
        user: false,
        payment: false,
        lightbox: {
          open: false,
          image: '',
        },
        verify: {
          open: false,
          message: '',
        }
      },

      loading: {
        search: false,
      },

      alert: {
        search: false,
      },

      apiUrl: 'nid-verify',

      // Need to fetch base URL from settings API
      // mediaBaseURL: '//live.v1.shadhinapp.com/public/imports/',
      mediaBaseURL: '//app.shadhinbd.com/imports/',

      user: {
        id: null,
        phone: '',
        name: 'n/a',
        dob: 'n/a',
        nid: {
          id: 'n/a',
          status: null,
          front: null,
          back: null,
        },
        gender: 'n/a',
        isVerified: null,
        photo: null,
      },

      phoneMask: '###########',

      rules: {
        required: value => !!value || 'This field is required',
        min: value => value.length >= 11 || 'Invalid number',
      },
    }),

    computed: {
      ...mapGetters(['isLoggedIn', 'indexData', 'error', 'errorMsg', 'statusCode']),
    },

    created () {
      this.initialize()
    },

    mounted () {
      this.$nextTick(() => this.$refs.userphone.focus());
      this.user.phone = this.$route.query.phone;
    },

    methods: {
      initialize () {
        this.$store.dispatch('resetAll')
      },

      async search () {
        // Exit search if the phone number is invalid
        if (!this.isValidPhone()) { return }

        // Enable loading
        this.loading.search = true

        // Disable alert message if any
        this.alert.search = false

        // Search for user
        // await this.$store.dispatch('changeStatus', ['funding-list', 8, this.userPhone, 1, 10])
        await this.$store.dispatch('getPaginatedIndexData', ['investee-all-data', this.user.phone, 1, 10])

        // Map data
        if(this.error == 0 && this.statusCode == 200) {
          try {
            // Save user's data from response
            let user = this.indexData.data[0]

            this.user.name = user.name
            this.user.id = user.id
            this.user.dob = user.basic_info.dob
            this.user.nid.id = user.basic_info.gov_id_no
            this.user.gender = this.getGenderTitle(user.basic_info.gender_id)
            this.user.isVerified = user.basic_info.is_nid_verified

            // Photos
            this.user.photo     = this.getURL(user.document.photo, 'photos')
            this.user.nid.front = this.getURL(user.document.nid_front_page, 'documents')
            this.user.nid.back  = this.getURL(user.document.nid_back_page, 'documents')
          } catch (err) {
            // Promt an alert for FAT Member
            alert("User's profile is not complete.")
          }

          // Hide dialog and reset indexData
          this.dialog.search.open = false

          // Reset response data
          this.initialize()
        } else {
          // Something went wrong. Allow to searh again
          this.alert.search = true
          this.$nextTick(() => this.$refs.userphone.focus());
        }

        // Disable Loading
        this.loading.search = false
      },

      retry () {
        this.dialog.search.open = true
        this.$nextTick(() => this.$refs.userphone.focus());
      },

      isValidPhone () {
        return this.$refs.userphone ? this.$refs.userphone.valid : false
      },

      /*
       * Convert Gender ID to Title
       *
       * @param {Integer} id
       * @return {String}
       */
      getGenderTitle (id) {
        let title = ''
        switch(id) {
          case 1:
            title = 'Male'
            break
          case 2:
            title = 'Female'
            break
          case 3:
            title = 'Others'
            break
          case null:
            title = 'N/A'
            break
          default:
            title = 'Unknown gender ID'
        }

        return title
      },

      getURL(filename, type) {
        if (filename) {
          // Return image URL
          return this.mediaBaseURL + type + '/' + filename
        } else {
          // Image not found
          return require('../../assets/image-404.jpg')
        }
      },

      imgLoading() {
        return require('../../assets/loading.gif')
      },

      imgLightbox(imgURL) {
        this.dialog.lightbox.open = true
        this.dialog.lightbox.image = imgURL
      },

      async verify() {
        // Open the dialog
        this.dialog.verify.open = true
        this.dialog.verify.message = ''

        if(!this.user.dob || !this.user.nid.id) {
          this.dialog.verify.message = "Users's 'Date of Birth' and 'NID Number' are required to perform verification."
          return
        }

        let requestData = {
          'user_id': this.user.id,
          'search_type': 2,
        }

        try {
          await this.$store.dispatch('store', [this.apiUrl, requestData])
        } catch (err) {
          this.dialog.verify.message = err
          return
        }


        // this.dialog.verify.message = "Request Sent! The verification process might take a few minutes to complete."
        this.dialog.verify.message = this.errorMsg
        return
      },
    }
  }
</script>